<template>
  <!-- Visão em Grid -->
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="items"
    item-key="IdSql"
    class="elevation-1"
    rows-per-page-text="Registros"
    select-all
    :pagination.sync="pagConfigSql"
    :loading="loading"
    :search="searchTerm"
    no-data-text="Nenhum registro encontrado"
    @update:pagination="updatePagination"
  >
    <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
    <template v-slot:items="props">
      <tr
        :active="props.selected"
        class="cursor-pointer"
        @dblclick="$emit('editItemSelected', props.item)"
        @click="props.selected = !props.selected"
      >
        <td>
          <v-checkbox :input-value="props.selected" primary color="primary" hide-details></v-checkbox>
        </td>
        <td>{{ props.item.IdSql }}</td>
        <td>{{ props.item.Descricao }}</td>
        <td>
          <v-avatar size="32" :color="statusSql(props.item.Status)">
            <span class="white--text">{{ props.item.Status[0] }}</span>
          </v-avatar>
        </td>
      </tr>
    </template>
    <template v-slot:no-results>
      <v-alert
        :value="true"
        color="error"
        icon="warning"
      >Pesquisa por "{{ searchTerm }}" não encontrou resultados.</v-alert>
    </template>
    <template
      v-slot:pageText="props"
    >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
  </v-data-table>
  <!-- Fim Visão em Grid -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'GridSql',
  props: ['searchTerm', 'items', 'loading'],
  data: () => ({
    headers: [
      { text: 'ID', align: 'left', value: 'IdSql' },
      { text: "Descrição", value: "Descricao" },
      { text: "Status", value: "Status" }
    ],
    pagConfigSql: {
      descending: true,
      page: 1,
      rowsPerPage: 10, // -1 for All"
      sortBy: "IdSql"
    }
  }),
  computed: {
    ...mapGetters(['sqlsSelected']),
    selected: {
      // getter
      get: function () {
        return this.sqlsSelected;
      },
      set: function (value) {
        this.selectSqls(value);
      }
    }
  },
  methods: {
    ...mapActions(['selectSqls', 'resetSqlsSelected']),
    salvaConfigPesquisa() {
      localStorage.setItem("GridSqlPagConfig", JSON.stringify(this.pagConfigSql));
    },
    recuperaConfigPesquisa() {
      // Verifica se existe no localStorage o item GridSqlPagConfig salvo anteriormente
      if (localStorage.getItem('GridSqlPagConfig')) {
        this.pagConfigSql = JSON.parse(localStorage.getItem('GridSqlPagConfig'));
      }
    },
    updatePagination() {
      this.salvaConfigPesquisa();
    },
    statusSql(status) {
      if (status.includes('A')) return "#263238";
      if (status.includes('C')) return "#bdbdbd";
    },
  },
  created() {
    this.recuperaConfigPesquisa();
  }
}
</script>

<style>

</style>